import { useCallback } from 'react';

import { Box, Button } from '@frontierag/frontier-ui-library';
import { Add as AddIcon, Remove as RemoveIcon } from '@frontierag/frontier-ui-library/icons';

import type { IQuantityControl } from './types';

export default function QuantityControl({
  quantity,
  minQuantity,
  maxQuantity,
  onChange,
}: IQuantityControl) {
  const handleIncrease = useCallback(() => onChange(quantity + 1), [onChange, quantity]);
  const handleDecrease = useCallback(() => onChange(quantity - 1), [onChange, quantity]);

  return (
    <Box display="flex" alignItems="center" gap={1} data-testid="quantity-control">
      <Button
        color="primary"
        variant="contained"
        disabled={Boolean(minQuantity && quantity <= minQuantity)}
        onClick={handleDecrease}
        sx={{ width: 24, height: 24, minWidth: 'auto', p: 0 }}
        data-testid="quantity-control-decrease"
      >
        <RemoveIcon />
      </Button>
      <Box data-testid="quantity-control-value">{quantity}</Box>
      <Button
        variant="contained"
        color="primary"
        disabled={Boolean(maxQuantity && quantity >= maxQuantity)}
        onClick={handleIncrease}
        sx={{ width: 24, height: 24, minWidth: 'auto', p: 0 }}
        data-testid="quantity-control-increase"
      >
        <AddIcon />
      </Button>
    </Box>
  );
}
